// import { X } from 'lucide-react';
// import { useState, useEffect } from 'react';
// import { useUpdateCustomerStatus } from '../hooks/useUpdateCustomerStatus';
// const StatusUpdateModal = ({ isOpen, onClose, customer }) => {
//   const [status, setStatus] = useState(customer?.status || '');
//   const [reason, setReason] = useState('');
//   const { mutate: updateStatus, isPending } = useUpdateCustomerStatus();

//   useEffect(() => { setStatus(customer?.status || ''); setReason(''); }, [customer]);

//   if (!isOpen) return null;

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     updateStatus(
//       {
//         customerId: customer._id,
//         status,
//         suspensionReason: reason || undefined,
//       },
//       {
//         onSuccess: () => {
//           onClose();
//           setReason('');
//         },
//       }
//     );
//   };

//   const statusOptions = [
//     { value: 'active', label: 'Active', description: 'Customer can use services normally' },
//     { value: 'inactive', label: 'Inactive', description: 'Customer account is temporarily inactive' },
//     // { value: 'suspended', label: 'Suspended', description: 'Customer account is suspended' },
//     // { value: 'blocked', label: 'Blocked', description: 'Customer account is permanently blocked' },
//   ];

//   const hasStatusChanged = status !== customer?.status;

//   return (
//     <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm'>
//       <div className='bg-card border border-border rounded-lg shadow-lg w-full max-w-md mx-4'>
//         {/* Header */}
//         <div className='flex items-center justify-between p-6 border-b border-border'>
//           <h2 className='text-lg font-semibold text-foreground'>Update Customer Status</h2>
//           <button
//             onClick={onClose}
//             className='text-muted-foreground hover:text-foreground transition-colors'
//             disabled={isPending}
//           >
//             <X size={20} />
//           </button>
//         </div>

//         {/* Content */}
//         <form onSubmit={handleSubmit} className='p-6 space-y-4'>
//           <div>
//             <label className='block text-sm font-medium text-foreground mb-2'>Select Status</label>
//             <div className='space-y-2'>
//               {statusOptions.map((option) => (
//                 <label
//                   key={option.value}
//                   className='flex items-start p-3 border border-border rounded-md cursor-pointer hover:bg-accent transition-colors'
//                 >
//                   <input
//                     type='radio'
//                     name='status'
//                     value={option.value}
//                     checked={status === option.value}
//                     onChange={(e) => setStatus(e.target.value)}
//                     className={'mt-1 !bg-none checked:!bg-blue-500 !border-none focus:!outline-none'}
//                     required
//                   />
//                   <div className='ml-3'>
//                     <div className='text-sm font-medium text-foreground capitalize'>{option.label}</div>
//                     <div className='text-xs text-muted-foreground'>{option.description}</div>
//                   </div>
//                 </label>
//               ))}
//             </div>
//           </div>

//           {(status === 'suspended' || status === 'blocked') && (
//             <div>
//               <label htmlFor='reason' className='block text-sm font-medium text-foreground mb-2'>
//                 Reason (Required)
//               </label>
//               <textarea
//                 id='reason'
//                 value={reason}
//                 onChange={(e) => setReason(e.target.value)}
//                 rows={3}
//                 className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-primary'
//                 placeholder='Enter reason for status change...'
//                 required={status === 'suspended' || status === 'blocked'}
//               />
//             </div>
//           )}

//           {/* Footer */}
//           <div className='flex justify-end gap-3 pt-4'>
//             <button
//               type='button'
//               onClick={onClose}
//               className='px-4 py-2 text-sm border border-border rounded-md bg-card hover:bg-accent transition-colors'
//               disabled={isPending}
//             >
//               Cancel
//             </button>
//             <button
//   type='submit'
//   className='px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
//   disabled={isPending || !hasStatusChanged}
// >
//   {isPending ? 'Updating...' : 'Update Status'}
// </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default StatusUpdateModal;



import { X } from 'lucide-react';
import { useState, useEffect } from 'react';
import { useUpdateCustomerStatus } from '../hooks/useUpdateCustomerStatus';
const StatusUpdateModal = ({ isOpen, onClose, customer }) => {
  const [status, setStatus] = useState(customer?.status || '');
  const [reason, setReason] = useState('');
  const { mutate: updateStatus, isPending } = useUpdateCustomerStatus();

  useEffect(() => { setStatus(customer?.status || ''); setReason(''); }, [customer]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    updateStatus(
      {
        customerId: customer._id,
        status,
        suspensionReason: reason || undefined,
      },
      {
        onSuccess: () => {
          onClose();
          setReason('');
        },
      }
    );
  };

  const statusOptions = [
    { value: 'active', label: 'Active', description: 'Customer can use services normally', radioClass: 'checked:!bg-green-500' },
    { value: 'inactive', label: 'Inactive', description: 'Customer account is temporarily inactive', radioClass: 'checked:!bg-blue-500' },
    // { value: 'suspended', label: 'Suspended', description: 'Customer account is suspended' },
    // { value: 'blocked', label: 'Blocked', description: 'Customer account is permanently blocked' },
  ];

  const hasStatusChanged = status !== customer?.status;

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm'>
      <div className='bg-card border border-border rounded-lg shadow-lg w-full max-w-md mx-4'>
        {/* Header */}
        <div className='flex items-center justify-between p-6 border-b border-border'>
          <h2 className='text-lg font-semibold text-foreground'>Update Customer Status</h2>
          <button
            onClick={onClose}
            className='text-muted-foreground hover:text-foreground transition-colors'
            disabled={isPending}
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className='p-6 space-y-4'>
          <div>
            <label className='block text-sm font-medium text-foreground mb-2'>Select Status</label>
            <div className='space-y-2'>
              {statusOptions.map((option) => (
                <label
                  key={option.value}
                  className='flex items-start p-3 border border-border rounded-md cursor-pointer hover:bg-accent transition-colors'
                >
                  <input
                    type='radio'
                    name='status'
                    value={option.value}
                    checked={status === option.value}
                    onChange={(e) => setStatus(e.target.value)}
                    className={`mt-1 !bg-none !border-none focus:!outline-none ${option.radioClass}`}
                    required
                  />
                  <div className='ml-3'>
                    <div className='text-sm font-medium text-foreground capitalize'>{option.label}</div>
                    <div className='text-xs text-muted-foreground'>{option.description}</div>
                  </div>
                </label>
              ))}
            </div>
          </div>

          {(status === 'suspended' || status === 'blocked') && (
            <div>
              <label htmlFor='reason' className='block text-sm font-medium text-foreground mb-2'>
                Reason (Required)
              </label>
              <textarea
                id='reason'
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                rows={3}
                className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-primary'
                placeholder='Enter reason for status change...'
                required={status === 'suspended' || status === 'blocked'}
              />
            </div>
          )}

          {/* Footer */}
          <div className='flex justify-end gap-3 pt-4'>
            <button
              type='button'
              onClick={onClose}
              className='px-4 py-2 text-sm border border-border rounded-md bg-card hover:bg-accent transition-colors'
              disabled={isPending}
            >
              Cancel
            </button>
            <button
              type='submit'
              className='px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
              disabled={isPending || !hasStatusChanged}
            >
              {isPending ? 'Updating...' : 'Update Status'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StatusUpdateModal;